import { useCallback, useMemo, useState } from 'react';
import { isPhoneValid } from '../../../../../utils/isPhoneValid';
import { formatPhoneNumber } from '../../../../../utils/formatPhoneNumber';
import { useDispatch, useSelector } from 'react-redux';
import { selectDemandRequest } from '../../../../../selectors/dataPayment';
import { bindActionCreators } from 'redux';
import { setDemandRequestPhone } from '../../../../../actions/dataPayment';

export const usePhoneValue = () => {
  const { phone = '' } = useSelector(selectDemandRequest);
  const dispatch = useDispatch();
  const boundActions = useMemo(
    () =>
      bindActionCreators(
        {
          setDemandRequestPhone,
        },
        dispatch,
      ),
    [dispatch],
  );

  const [isValid, setIsValid] = useState(isPhoneValid(phone));

  const onChange = useCallback(
    (newValue: string) => {
      const formatted = formatPhoneNumber(newValue);
      boundActions.setDemandRequestPhone(formatted);
      setIsValid(isPhoneValid(formatted));
    },
    [boundActions],
  );

  return {
    phone,
    isValid,
    onChange,
  };
};
